import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import type { EvalTypeMetadata } from '@/types/eval-v2-types';

interface EvalDescriptionPanelProps {
  metadata: EvalTypeMetadata;
}

export default function EvalDescriptionPanel({
  metadata,
}: EvalDescriptionPanelProps) {
  return (
    <Accordion type='single' collapsible className='mb-6'>
      <AccordionItem
        value='description'
        className='rounded-md border border-border bg-muted-background last:border-b'
      >
        <AccordionTrigger className='px-4 py-3 text-sm font-medium hover:no-underline [&>svg]:hidden'>
          <span className='flex items-center gap-1.5'>
            <ChevronDown className='h-4 w-4 text-muted-foreground transition-transform duration-200 in-data-[state=open]:rotate-180' />
            About this evaluation
          </span>
        </AccordionTrigger>
        <AccordionContent className='px-4 pb-4 text-sm'>
          {metadata.description &&
            metadata.description.split('\n\n').map((paragraph, i) => (
              <p
                key={i}
                className={`text-muted-foreground ${i < metadata.description.split('\n\n').length - 1 ? 'mb-2' : metadata.sections.length > 0 ? 'mb-4' : ''}`}
              >
                {paragraph}
              </p>
            ))}

          {metadata.sections.map((section) => (
            <div key={section.heading} className='mb-4 last:mb-0'>
              <p className='font-medium mb-1.5'>{section.heading}</p>
              <ul className='space-y-1 text-muted-foreground'>
                {section.items.map((item, i) => (
                  <li key={i} className='flex items-start gap-2'>
                    <span className='shrink-0 mt-1.5 h-1 w-1 rounded-full bg-muted-foreground' />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {metadata.tip && (
            <div className='mt-4 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200'>
              <span className='font-medium'>Tip: </span>
              {metadata.tip}
            </div>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
